import type {
  QBankStructureType,
  QConfigStructureCategory,
  QConfigStructureType,
} from '@exam-management/graphql';
import type { OptionSelectionProps } from '@shared/components';

export interface GroupOption extends OptionSelectionProps {
  inputValue?: string;
}

export interface GroupFormFieldSlotProps {
  options: GroupOption[];
  isLoading: boolean;
  onChange?: (input: string) => void;
  onInputChange?: (input: string) => void;
  onOpen?: (currentValue: string) => void;
  onClose?: () => void;
  onBlur?: (currentValue: string) => void;
  onClear?: () => void;
}

export interface CreateQBankStructureFormInput {
  name: string;
  description: string;
  remark: string;
  type: QBankStructureType;
  group?: GroupOption | null;
}

export interface QueryParam {
  name: string;
  value: unknown;
}

export enum WorkflowRole {
  TASK_ASSIGNEE = 'TASK_ASSIGNEE',
  TASK_ASSIGNER = 'TASK_ASSIGNER',
  TASK_OWNER = 'TASK_OWNER',
  SUBTASK_ASSIGNEE = 'SUBTASK_ASSIGNEE',
  SUBTASK_ASSIGNER = 'SUBTASK_ASSIGNER',
  SUBTASK_OWNER = 'SUBTASK_OWNER',
}

export interface QConfigTableData {
  id: string;
  name: string | null;
  refCode: string | null;
  refId: string;
  parentRefId: string;
  category: QConfigStructureCategory;
  type: QConfigStructureType;
  parentIds: string[];
  parentId: string;
  totalQuestions: number;
  scorePerQuestion: number;
  size: number | null;
  questionType: {
    single: number | null;
    itemSet: number | null;
  };
  calculated: {
    easy: number | null;
    medium: number | null;
    hard: number | null;
  };
  notCalculated: {
    easy: number | null;
    medium: number | null;
    hard: number | null;
  };
}
